// extracted by mini-css-extract-plugin
export var activeGameSession = "InteracPrimaryView-module--activeGameSession--3c9e0";
export var buttonSkeleton = "InteracPrimaryView-module--buttonSkeleton--8791b";
export var depositButton = "InteracPrimaryView-module--depositButton--3aa6f";
export var sectionHeaderSkeleton = "InteracPrimaryView-module--sectionHeaderSkeleton--6d503";